import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
// Service to handle local storage operations
export class LocalStorageService {

    constructor() {}

    setItem(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    getItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}
